<template>
  <center>
    <div v-if="(isLoggedIn || handleLogin())" class="card card-body agatrs-card-style">
      <div class="row">
        <div class="col-md-5 justify-content-start col-4">
          <base-button @click="$router.go(-1)"
            class="btn-dark float-sm-none float-md-left more-margin-top">Back</base-button>
        </div>
        <Header pageTitle="Advanced Search" class="justify-content-start"></Header>
        <div v-if="duringSubmit" class="loading">
          <Loading />
        </div>
      </div>

      <!-- 1st Row -->
      <div class="row">
        <div class="col-md-3">
          <label for="Sponsor">Sponsor</label>
          <v-select id="Sponsor" v-model="selectedSponsorBy" name="SponsorByDropdown" :reduce="(item) => item.id"
            label="name" :options="optionsSponsorBy" placeholder="Select">
            <template v-slot:option="option">
              {{ option.firstName }} {{ option.lastName }}
              <i v-if="option.approvalStatusId == lockedStatusID" class="tim-icons icon-lock-circle">{{ approveText
                }}</i>
            </template>
          </v-select>
        </div>

        <div class="col-md-3">
          <label for="role">Role</label>
          <v-select id="role" v-model="selectedRole" name="roleDropdown" :reduce="(item) => item.name" label="name"
            :options="optionsRole" placeholder="Select"></v-select>
        </div>
        <div class="col-md-3">
          <label for="Organization">Organization</label>
          <base-input :error="getError('organization')" aria-label="Organization">
            <div class="required_input_grid">
              <div class="grid_column_1 grid_center_item input_field_text color_red"></div>
              <treeselect @input="filterApprover" v-model="organizationId" :normalizer="normalizer"
                class="select-primary" name="organization" :multiple="false" :clearable="true" :searchable="true"
                :disabled="false" :open-on-click="true" :open-on-focus="false" :clear-on-select="false"
                :close-on-select="true" :always-open="false" :append-to-body="false" search-nested
                :options="jointStaffOrganizations" placeholder="Select" />
            </div>
          </base-input>
        </div>
        <div class="col-md-3">
          <label for="ApprovalStatus">Approval Status</label>
          <v-select :multiple="true" id="ApprovalStatus" v-model="selectedApprovalStatus" name="ApprovalStatusDropdown"
            :reduce="(item) => item.approvalStatusId" label="name" :options="optionsApprovalStatus"
            placeholder="Select"></v-select>
        </div>
        <div class="col-sm-3">
          <label for="Service">Service / Parent Organization </label>
          <base-input>
            <v-select v-model="serviceValue" name="service" :options="services" :reduce="service => service.serviceId"
              label="name" placeholder="Select">
            </v-select>
          </base-input>
        </div>
      </div>

      <!-- 7th Row (Search and Clear Buttons) -->
      <div class="row more-top-padding">
        <div class="col-md-4 d-flex justify-content-start col-4"></div>

        <div class="col-md-4 d-flex justify-content-center col-4">
          <base-button @click="initializeAllData()" type="danger"
            class="float-sm-none float-md-left more-margin-top btn-default" v-b-popover.hover.top="'Reset all fields!'">
            <i class="tim-icons icon-alert-circle-exc"></i> Clear
          </base-button>
          <base-button @click="search()" type="primary" class="float-sm-none float-md-left more-margin-top btn-default"
            v-b-popover.hover.right="'Search results will appear below.'">
            <i class="tim-icons icon-zoom-split"></i> Search
          </base-button>
        </div>
      </div>
      <hr />
      <br />

      <div>
        <h3>Search Results</h3>
        <div>
          <div class="row">
            <export-group v-bind:isLoading="duringSubmit" v-on:loading="toggleLoading" :name="'Users'"
              :getData="getExportData" :excelExportCustom="excelExport" :isUsingCustomExcel="true">
            </export-group>
          </div>
          <div class="row">
            <el-table :data="getResults" :default-sort="{ prop: 'orderId', order: 'descending' }"
              aria-label="Order search results table">
              <el-table-column :min-width="110" align="left" label="Actions">
                <div slot-scope="scope">
                  <span class="hide-if-medium-screensize"></span>
                  <router-link :to="'/admin/profile/' + scope.row.id" class="btn-link btn-primary">
                    <i v-if="!isOUSD" class="tim-icons icon-pencil"></i>
                    <span v-if="!isOUSD" class="hide-if-small-screensize">Edit</span>
                    <span v-else class="hide-if-small-screensize">View</span>
                  </router-link>
                  <lock-button v-if="scope.row.approvalStatusName === 'APPROVED'"
                    v-on:reloadUnlockLockInfo="reloadUnlockLockInfo(scope.row.id)"
                    v-bind:organizationId="user.organizationId" :isUserPage="true" :id="scope.row.id"
                    :userName="scope.row.firstName + ' ' + scope.row.lastName"></lock-button>
                </div>
              </el-table-column>

              <el-table-column v-for="column in filteredColumns" sortable :key="column.label"
                :min-width="column.minWidth" :prop="column.prop" :label="column.label"></el-table-column>
              <el-table-column :min-width="150" prop="approvalStatusName" :key="'approvalStatus'" align="left"
                label="Approval Status" sortable>
                <div slot-scope="scope">

                  <el-tooltip v-if="scope.row.approvalStatusName === 'APPROVED'" effect="dark" placement="top-start"
                    :content="scope.row.lockUnlockDate ? localtimeZone(scope.row.lockUnlockDate) : localtimeZone(scope.row.approvalDate)">
                    <p style="color:rgba(34, 42, 66, 0.7) !important">{{ scope.row.approvalStatusName }}</p>
                  </el-tooltip>
                  <el-tooltip v-if="scope.row.approvalStatusName === 'PENDING'" effect="dark" placement="top-start"
                    :content="scope.row.lockUnlockDate ? localtimeZone(scope.row.lockUnlockDate) : localtimeZone(scope.row.createDate)">
                    <p style="color:rgba(34, 42, 66, 0.7) !important">{{ scope.row.approvalStatusName }}</p>
                  </el-tooltip>
                  <el-tooltip v-if="scope.row.approvalStatusName === 'REJECTED'" effect="dark" placement="top-start"
                    :content="scope.row.lockUnlockDate ? localtimeZone(scope.row.lockUnlockDate) : localtimeZone(scope.row.createDate)">
                    <p style="color:rgba(34, 42, 66, 0.7) !important">{{ scope.row.approvalStatusName }}</p>
                  </el-tooltip>
                  <el-tooltip v-if="scope.row.approvalStatusName === 'LOCKED'" effect="dark" placement="top-start"
                    :content="scope.row.lockUnlockDate ? localtimeZone(scope.row.lockUnlockDate) : localtimeZone(scope.row.createDate)">
                    <p>{{ scope.row.approvalStatusName }}</p>
                  </el-tooltip>
                </div>
              </el-table-column>
            </el-table>
            <b-modal ref="showDetailsModal" scrollable hide-footer hide-header no-close-on-backdrop size="lg"
              body-class="custom_alert_body">
              <div class="alert_header align-center">
                <br />
                Additional Information for Order ID: {{ this.selectedOrderId }}
              </div>
              <div class="container">
                <div class="row">
                  <div class="col-sm-12">
                    <label for="organization">Organization:</label>
                    <base-input id="organization" disabled v-model="this.organization"></base-input>

                    <label for="agreedReturnDate">Agreed Return Date:</label>
                    <base-input id="agreedReturnDate" disabled v-model="this.agreedReturnDateLabel"></base-input>
                  </div>
                  <div class="col-sm-6">
                    <label for="deliveryStartDate">Delivery Start Date</label>
                    <base-input id="agreedReturnDate" disabled v-model="this.deliveryStartDateLabel"></base-input>
                  </div>
                  <div class="col-sm-6">
                    <label for="deliveryEndDate">Delivery End Date</label>
                    <base-input id="agreedReturnDate" disabled v-model="this.deliveryEndDateLabel"></base-input>
                  </div>

                </div>
              </div>

              <div class="alert_footer align-center">
                <base-button type="primary" @click="clickCloseModal()" class="btn-primary">
                  <i class="tim-icons icon-double-left"></i> Return to Table
                </base-button>
              </div>
            </b-modal>
          </div>
        </div>
      </div>
    </div>

  </center>

</template>

<script>
// import UserAdvancedSearch from "@/components/App/admin/UserAdvancedSearch.vue";
import axios from "@/axios";
import Header from "@/components/App/Header.vue";
import Treeselect from "@riophae/vue-treeselect";
import { mapGetters, mapActions } from "vuex";
import { Select, Option, Tooltip, Table, TableColumn } from "element-ui";
import LockButton from "@/components/App/account/LockButton.vue";
import { Modal, BasePagination, ExportGroup } from "@/components";
import Loading from 'src/components/LoadingPanel';

import Util from "@/util/util";

export default {
  name: "Search",
  components: {
    Header,
    [Select.name]: Select,
    [Option.name]: Option,
    [Tooltip.name]: Tooltip,
    Treeselect,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Modal,
    BasePagination,
    Loading,
    LockButton,
    ExportGroup
  },
  async mounted() {
    if (!this.user) {
      this.getUserByEmail();
    }
    this.getAllRoles();
    this.getServices();
    this.getUserStatus();
    this.getSponsor();
    this.getJointStaffOrganizations();
    this.getAllOrganization();
    await this.getApprovalStatuses();
    this.getUsers();
    //this.clearSearchCriteria();
    //this.clearSearchResults();

    //lucas 7/25/22
    this.getPreLoadedSearchCriteria();

  },
  data() {
    return {
      map: {
        "Email": "email",
        "Service": "serviceName",
        "SponsorName": "sponsorName",
        "SponsorApprovalStatus": "sponsorApprovalStatusName",
        "FirstName": "firstName",
        "LastName": "lastName",
        "Roles": "roles",
        "Parent": "parentName",
        "Organization": "organizationName",
        "ApprovalStatus": "approvalStatusName",
        "LastAccessed": "lastLoginDate",
      },
      selectedApprovedBy: "",
      selectedSponsorBy: "",
      optionsApprovedBy: [],
      optionsSponsorBy: [],
      optionsRole: [],
      selectedRole: "",
      selectedOrganization: "",
      organizationId: null,
      organizationIds: [],
      selectedApprovalStatus: [],
      optionsApprovalStatus: [],
      selectedOrderId: 0,
      organization: "",
      agreedReturnDateLabel: "",
      deliveryStartDateLabel: "",
      deliveryEndDateLabel: "",
      serviceValue: "",
      excelLoadTime: 0,
      searchTimeOut: null,
      searchText: "",
      selectedResultsPerPage: 10,
      selectedPage: 1,
      duringSubmit: false,

      // column helpers
      filteredColumnData: [],
      organizationTableColumns: [
        {
          prop: "organizationName",
          label: "Organization",
          minWidth: 130,
        }
      ],
      countryTableColumns: [
        {
          prop: "countryName",
          label: "Country",
          minWidth: 130,
        }
      ],
      tableColumns: [
        {
          prop: "email",
          label: "User Email",
          minWidth: 140,
        },
        {
          prop: "sponsorName",
          label: "Sponsor Name",
          minWidth: 120,
        },
        {
          prop: "firstName",
          label: "First Name",
          minWidth: 100,
        },
        {
          prop: "lastName",
          label: "Last Name",
          minWidth: 100,
        },
        {
          prop: "roles",
          label: "Roles",
          minWidth: 90,
        }
      ],
      results: null,
    };


  },
  watch: {
    searchText(value) {
      clearTimeout(this.searchTimeOut);

      var self = this;
      let tempSearchCriteria = this.searchCriteria;
      tempSearchCriteria.SearchText = value;
      self.setSearchCriteria(tempSearchCriteria);
      self.searchTimeOut = setTimeout(function () {
        self.getSearchResults();
      }, 1000);
    },
    selectedResultsPerPage(value) {
      let tempSearchCriteria = this.searchCriteria;
      tempSearchCriteria.PageNumber = 1;
      tempSearchCriteria.ResultsPerPage = value;
      this.search(tempSearchCriteria);
    },
    selectedPage(value) {
      let tempSearchCriteria = this.searchCriteria;
      tempSearchCriteria.PageNumber = value;
      this.search(tempSearchCriteria);
    },
    selectedSponsorBy(value) {
      this.setSearchCriteriaObject();
      //console.log("updating search criteria for sponsor ID", this.searchCriteria);
    },
    selectedRole(value) {

      this.setSearchCriteriaObject();
      // console.log("updating search criteria for ROLE ID", this.searchCriteria);
    },
    organizationId(value) {

      this.setSearchCriteriaObject();
      console.log("updating search criteria for ORGANIZATION ID", this.searchCriteria);
    },
    selectedApprovalStatus(value) {
      // console.log(value);

      this.setSearchCriteriaObject();
      // console.log("updating search criteria for APPROVAL STATUS ID", this.searchCriteria);
    }
  },

  computed: {
    ...mapGetters({
      isLoggedIn: "authentication/isLoggedIn",
      partnerNationOptions: "countries/allCountries",
      operationTheaterOptions: "operationTheaters/allOperationTheatres",
      methodOfPaymentOptions: "paymentmethod/paymentMethods",
      lsssTypeOptions: "lsstype/allLssTypes",
      assignedLogisticsUserOptions: "users/logisticsUsers",
      assignedFinanceUserOptions: "users/financeUsers",
      services: "services/services",
      createdByOptions: "users/allUsers",
      user: "adminUsers/user",
      fiscalYears: "fiscalYears/fiscalYears",
      searchResults: "orders/searchResults",
      searchCriteria: "orders/searchCriteria",
      jointStaffOrganizations: "organization/jointStaffOrganizations",
      approvalStatuses: "approvalStatus/approvalStatuses",
      isOUSD: "authentication/isOUSD",
    }),
    filteredColumns() {
      return this.filteredColumnData;
    },
    lockedStatusID() {
      const lockedStatus = this.approvalStatuses.find(a => a.name === 'LOCKED')
      return lockedStatus ? lockedStatus.approvalStatusId : null;
    },
    fiscalYearStart() {
      return this.selectedFiscalYear
        ? new Date(this.selectedFiscalYear - 1, 9, 1).toISOString()
        : null;
    },
    fiscalYearEnd() {
      return this.selectedFiscalYear
        ? new Date(this.selectedFiscalYear, 8, 30).toISOString()
        : null;
    },
    selectedLogisticsUserLabel() {
      let selectedUser;
      if (this.selectedAssignedLogisticsUser) {
        selectedUser = this.assignedLogisticsUserOptions.find(
          (user) => user.id === this.selectedAssignedLogisticsUser
        );
      }
      return selectedUser
        ? selectedUser.nameLabel
        : "No Logistics user selected";
    },
    selectedFinanceUserLabel() {
      let selectedUser;
      if (this.selectedAssignedFinanceUser) {
        selectedUser = this.assignedFinanceUserOptions.find(
          (user) => user.id === this.selectedAssignedFinanceUser
        );
      }
      return selectedUser
        ? selectedUser.nameLabel
        : "No Logistics user selected";
    },
    getResults() {
      return Util.isNullOrEmpty(this.results) ? [] : this.results;
    },
    validOrgIds(){
return this.organizationIds.length > 0 && this.organizationId ? 
        this.organizationIds
          .filter(id => id != null && id !== "" && !isNaN(id) && parseInt(id) > 0)
          .map(id => parseInt(id))
        : [];
    }
  },
  methods: {
    ...mapActions({
      getAllCountries: "countries/getAllCountries",
      getAllOperationTheatres: "operationTheaters/getAllOperationTheatres",
      getPaymentMethods: "paymentmethod/getPaymentMethods",
      getLssTypes: "lsstype/getLssTypes",
      getLogisticsUsers: "users/getLogisticsUsers",
      getApprovalStatuses: "approvalStatus/getApprovalStatuses",
      getServices: "services/getServices",
      getFinanceUsers: "users/getFinanceUsers",
      getUsers: "users/getUsers",
      getFiscalYears: "fiscalYears/getFiscalYears",
      setSearchCriteria: "orders/setSearchCriteria",
      clearSearchCriteria: "orders/clearSearchCriteria",
      getSearchResults: "orders/getSearchResults",
      clearSearchResults: "orders/clearSearchResults",
      getUserByEmail: "users/getUserByEmail",
      getJointStaffOrganizations: "organization/getJointStaffOrganizations",
      getOrdersBySearchFieldsToExcel: "orders/getOrdersBySearchFieldsToExcel",
    }),
    async toggleLoading(action) {
      this.duringSubmit = action;
    },
    toggleColumns() {
      var additional = this.selectedRole.toUpperCase() === "PARTNERNATION"
        ? this.countryTableColumns
        : this.organizationTableColumns;

      this.filteredColumnData = [...this.tableColumns, ...additional];
    },
    async getExportData() {
      if (this.results == null || this.results.length == 0) {
        this.$toast.error("No users to be exported!");
      }


      var map = Util.mapTheData(this.results, this.map);

      return map;
    },
    //NEW (12/4/24) custom method to retrieve Excel file from backend WITHOUT sending entire data set to the backend. It uses the search criteria to rebuild the data on the backend while the excel package is being generated. 
    async excelExport() {
      this.$loaderApp.addRequest();
      let searchQuery = {
        sponsorId: this.selectedSponsorBy,
        userRole: this.selectedRole,
        organizationIds: this.organizationIds,
        approvalStatusList: this.selectedApprovalStatus,
      };
      //console.log("go get excel data from the advanced search page", searchQuery);

      try {
        //console.log("attempting to post from advanced user search to excel export backend method...");

        let userSearchResults = await axios({
          url: "api/export/advancedusers/excel",
          method: "POST",
          data: searchQuery,
          responseType: "blob",
          config: { showToast: false },
        });

        try {
          // console.log("attempting to package data as excel...");
          Util.fileDownload(userSearchResults.data, `Advanced Users.xlsx`);
          this.$loaderApp.completeRequest();
        }
        catch (err) {
          this.$loaderApp.completeRequest();
          //console.log("failed when trying to package data...");
          this.$toast.error("Error on exporting data to Excel. Please try again later...");
        }

        return userSearchResults;
      } catch (err) {
        this.duringSubmit = false;
        this.$loaderApp.completeRequest();

        this.$toast.error("Error Exporting Data to Excel Sheet. Ensure search has returned results first. ");
      }
    },
    handleLogin() {
      if (!this.isLoggedIn) {
        this.$router.push("Login");
      }
    },
    initializeAllData() {
      this.selectedSponsorBy = '';
      this.selectedRole = '';
      this.organizationId = '';
      this.selectedApprovalStatus = [];
      this.setSearchCriteriaObject();
    },
    clickCloseModal() {
      this.$refs.showDetailsModal.hide();
    },
    getOrderById(orderIdFromHtml) {
      return this.getResults.find((order) => order.orderId === orderIdFromHtml);
    },
    clickShowDetailsModal(orderIdFromHtml) {
      this.selectedOrderId = orderIdFromHtml;
      this.organization = this.getOrderById(orderIdFromHtml).organization;
      this.agreedReturnDateLabel = this.getOrderById(
        orderIdFromHtml
      ).agreedReturnDateLabel;
      this.deliveryStartDateLabel = this.getOrderById(
        orderIdFromHtml
      ).deliveryStartDateLabel;
      this.deliveryEndDateLabel = this.getOrderById(
        orderIdFromHtml
      ).deliveryEndDateLabel;
      this.$refs.showDetailsModal.show();
    },
    async getAllStatuses() {
      const response = await this.axios.get("/api/orderstatuses");
      this.statusOptions = response.data;
    },
    async getUserStatus() {
      const response = await this.axios.get("api/approvalstatuses");
      this.optionsApprovalStatus = response.data;
    },
    async getSponsor() {
      const response = await this.axios.get("/api/applicationusers/sponsor");
      this.optionsSponsorBy = response.data;
    },
    async getSearchData(query) {
      this.duringSubmit = true;
      this.$loaderApp.addRequest();
      
      try {
        const userSearchResults = await axios.post(
          "/api/applicationusers/advancedusers/filter", query);
        this.results = userSearchResults.data;
        this.toggleColumns();
        return userSearchResults;
      } catch (err) {
        console.error("Search error:", err);
        
        const errorMessage = err.response?.status === 400 
          ? err.response.data?.message || "Invalid search criteria. Please check your inputs."
          : err.response?.status === 500 
            ? "Server error occurred. Please try again later."
            : err.request 
              ? "Network error. Please check your connection and try again."
              : "Error retrieving search results. Please verify your search criteria and try again.";
        
        this.$toast.error(errorMessage);
        this.results = [];
        return null;
      } finally {
        this.duringSubmit = false;
        this.$loaderApp.completeRequest();
      }
    },
    normalizer(node) {
      return {
        id: node.id,
        label: node.name || node.label || "Select",
        children: node.children || []
      }
    },
    async search() {
      this.$loaderApp.addRequest();
      this.duringSubmit = true;
      this.clearSearchResults();
      this.duringSubmit = true;
      // Filter out empty strings from organizationIds and make sure Ids are valid integers
      
      
      let searchQuery = {
        sponsorId: this.selectedSponsorBy,
        userRole: this.selectedRole,
        //organizationId: this.organizationId,
        organizationIds: this.organizationIds, // added to show all sub orgs. bug #17524
        approvalStatusList: this.selectedApprovalStatus,
        serviceId: this.serviceValue
      };

      // Include organizationIds only if there are actual values
      if (this.validOrgIds.length > 0) {
        searchQuery.organizationIds = this.validOrgIds;
      }

      // Check if any filters are selected
      const hasFilters =
        (this.selectedSponsorBy && this.selectedSponsorBy !== "") ||
        (this.selectedRole && this.selectedRole !== "") ||
        (this.validOrgIds.length > 0) ||
        (this.selectedApprovalStatus && this.selectedApprovalStatus.length > 0) ||
        (this.serviceValue && this.serviceValue !== "");

      if (!hasFilters) {
        this.duringSubmit = false;
        this.$loaderApp.completeRequest();
        this.$toast.error("Please select at least one filter to perform a search.");
        return;
      }

      this.$validator
        .validateAll()
        .then((result) => {
          if (result) {
            this.getSearchData(searchQuery);
            this.duringSubmit = false;
          } else {
            this.$toast.error("Please enter an Organization");
          }
          this.getSponsor();
          this.$loaderApp.completeRequest();
          this.duringSubmit = false;

        })
        .catch(() => {
          this.duringSubmit = false;
          this.$loaderApp.completeRequest();
          this.duringSubmit = false;
          return;
        });
      this.duringSubmit = false;

    },

    // DFS to find the parent
    findParent(child) {
      if (child.id === this.organizationId) return child;
      let len = child.children.length;
      if (len > 0) {
        for (let i = 0; i < len; i++) {
          let children = child.children[i];
          if (children.id === this.organizationId) {
            return children;
          } else {
            let ret = this.findParent(children);
            if (ret.id === this.organizationId) {
              return ret;
            }
          }
        }
      }
      return child;
    },
    // DFS to find all the children of a parent
    findAllChildrenId(children) {
      for (let i = 0; i < children.children.length; i++) {
        let child = children.children[i];
        // Only add valid integer IDs - this an effort to remove the empty string 
        if (child.id != null && !isNaN(child.id) && parseInt(child.id) > 0) {
          this.organizationIds.push(parseInt(child.id));
        }
        this.findAllChildrenId(child);
      }
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    filterApprover() {
      
      if (this.organizationId) {
        this.organizationIds = [];
        // find the parent
        var parent = this.findParent(this.jointStaffOrganizations[0]);
        // find the children;
        // Only add valid integer IDs - this an effort to remove the empty string 
        if (parent && parent.id != null && !isNaN(parent.id) && parseInt(parent.id) > 0) {
          this.organizationIds.push(parseInt(parent.id));
        }
        this.findAllChildrenId(parent);
      } else {
        this.organizationIds = [];
      }
    },
    async getAllRoles() {
      const response = await this.axios.get("/api/roles/public");
      const filteredRoles = response.data.filter(a => a.name != 'Pending')
      this.optionsRole = filteredRoles;
    },
    async getAllOrganization() {
      const response = await this.axios.get("/api/organizations");
      this.optionsOrganization = response.data;
    },
    localtimeZone(date) {
      return Util.formatDateWithLocalTimezone(date);
    },
    getPreLoadedSearchCriteria() {

      this.selectedSponsorBy = this.searchCriteria.sponsorId;
      this.selectedRole = this.searchCriteria.userRole;
      this.organizationId = this.searchCriteria.organizationId;
      this.selectedApprovalStatus = this.searchCriteria.approvalStatusList;
      this.serviceValue = this.searchCriteria.serviceId;

      if ((this.selectedSponsorBy != null && this.selectedSponsorBy != "") ||
        (this.selectedRole != null && this.selectedRole != "") ||
        (this.organizationId != null && this.organizationId != "") || (this.serviceId != null && this.serviceId != "") ||
        (this.selectedApprovalStatus != null && this.selectedApprovalStatus.length > 0)) {

        if (this.searchCriteria?.organizationId) {
          this.organizationIds.push(this.searchCriteria.organizationId);
        }

        //var parent = this.findParent(this.jointStaffOrganizations[0]);

        // this.findAllChildrenId(parent);        
        let searchQuery = {
          sponsorId: this.selectedSponsorBy,
          userRole: this.selectedRole,
          organizationIds: this.organizationIds,
          approvalStatusList: this.selectedApprovalStatus,
          serviceId: this.serviceValue
        };
        //if(searchQuery.approvalStatusList == null ) searchQuery.approvalStatusList =[];

        this.getSearchData(searchQuery);
      }
    },
    setSearchCriteriaObject() {
      if (this.selectedSponsorBy == null) this.selectedSponsorBy = "";
      if (this.selectedRole == null) this.selectedRole = "";
      if (this.organizationId == null) this.organizationId = "";
      if (this.selectedApprovalStatus == null) this.selectedApprovalStatus = [];
      if (this.serviceValue == null) this.serviceValue = "";
      let searchQuery = {
        sponsorId: this.selectedSponsorBy,
        userRole: this.selectedRole,
        organizationId: this.organizationId,
        approvalStatusList: this.selectedApprovalStatus,
        serviceId: this.serviceValue,
      };

      this.setSearchCriteria(searchQuery);
    },
    async reloadUnlockLockInfo(id) {
      var self = this;
      self.searchTimeOut = setTimeout(function () {
        self.search()
      }, 1000);
    },
  },
};
</script>